export default "__VITE_ASSET__Dt3FM1dM__"